import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { css } from '@emotion/react'
import { selectAgentsOnlineCount } from 'ducks/chat/selectors/presence'
import { pluralize } from 'util/strings'
import { doShowChatPresenceOverviewModal } from 'actions/modals'

const indicatorStyle = () => theme => css`
  color: ${theme.color.monochrome.white};
  font-weight: ${theme.fontWeight.medium};
  text-align: center;
  margin: 16px -16px;
  padding: 6px 0;
  border-top: 1px solid ${theme.color.mainNav.itemBackground};
  border-bottom: 1px solid ${theme.color.mainNav.itemBackground};
`

const countStyle = () => theme => css`
  color: ${theme.color.primary.brand};
  cursor: pointer;
`

const PresenceOverviewIndicator = () => {
  const count = useSelector(selectAgentsOnlineCount)
  const dispatch = useDispatch()
  const openModal = useCallback(
    () => {
      dispatch(doShowChatPresenceOverviewModal())
    },
    [dispatch]
  )

  return (
    <div onClick={openModal} css={indicatorStyle}>
      Online:{' '}
      <span css={countStyle}>
        {count} {pluralize(count, 'Agent')}
      </span>
    </div>
  )
}

export default PresenceOverviewIndicator
